import React from "react";

import YoutubePlayer from "../../components/Youtube";

const demo = () => {
  return <div className='player-wrapper'>
    <br />
    <br />
    <br />
    <br />
    <br />
    <br />
    <br />
    <YoutubePlayer
      url={'https://www.youtube.com/watch?v=D5SJSc9I7OE&t=194s'}

      playeris={"youtube"} />
  </div>;
};

export default demo;
